import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ERROR_CODES } from "@components/common/error";
import { PATHS } from "@constants/Paths";
import { AppLayout, AuthLayout, BoxLayout } from "@layouts";
import { PeekScreenLoader } from "@piiqtechnologies/ui-components";
import { useAuthContext } from "@stores/AuthContext";
const Landing = React.lazy(() => import("@pages/landing"));
const Results = React.lazy(() => import("@pages/results"));
const Login = React.lazy(() => import("@pages/login"));
const ForgotPassword = React.lazy(() => import("@pages/forgot-password"));
const ResetPassword = React.lazy(() => import("@pages/reset-password"));
const SSOLoginError = React.lazy(() => import("@pages/login-error"));
const AdminDashboard = React.lazy(() => import("@pages/admin-dashboard"));
const Home = React.lazy(() => import("@pages/home"));
const Overview = React.lazy(() => import("@pages/overview"));
const TermsConditionsAgreement = React.lazy(() => import("@pages/terms-conditions-agreement"));
const Error = React.lazy(() => import("@pages/error"));
const AppRoutes = () => {
    const { isAdmin } = useAuthContext();
    return (React.createElement(Suspense, { fallback: React.createElement(PeekScreenLoader, { layered: true }) },
        React.createElement(Routes, null,
            React.createElement(Route, { path: PATHS.LANDING, element: React.createElement(Landing, null) }),
            React.createElement(Route, { path: PATHS.RESULTS, element: React.createElement(Results, null) }),
            React.createElement(Route, { element: React.createElement(AppLayout, null) },
                React.createElement(Route, { element: React.createElement(BoxLayout, null) },
                    React.createElement(Route, { path: PATHS.LOGIN, element: React.createElement(Login, null) }),
                    React.createElement(Route, { path: PATHS.FORGOT_PASSWORD, element: React.createElement(ForgotPassword, null) }),
                    React.createElement(Route, { path: PATHS.RESET_PASSWORD, element: React.createElement(ResetPassword, null) }),
                    React.createElement(Route, { path: PATHS.LOGIN_ERROR, element: React.createElement(SSOLoginError, null) }),
                    React.createElement(Route, { path: PATHS.TERMS_CONDITIONS_AGREEMENT, element: React.createElement(TermsConditionsAgreement, null) }),
                    React.createElement(Route, { path: "*", element: React.createElement(Error, { errorCode: ERROR_CODES.PAGE_NOT_FOUND }) })),
                React.createElement(Route, { element: React.createElement(AuthLayout, null) }, isAdmin ? (React.createElement(React.Fragment, null,
                    React.createElement(Route, { path: PATHS.ADMIN_DASHBOARD, element: React.createElement(AdminDashboard, null) }),
                    React.createElement(Route, { path: PATHS.OVERVIEW, element: React.createElement(Overview, null) }))) : (React.createElement(React.Fragment, null,
                    React.createElement(Route, { path: PATHS.HOME, element: React.createElement(Home, null) }),
                    React.createElement(Route, { path: PATHS.OVERVIEW, element: React.createElement(Overview, null) }))))))));
};
export default AppRoutes;
